<template>
  <div>
    <template v-if="loading">
      <send-loading :loading="loading" :no-quote="true"></send-loading>
    </template>
    <template v-if="!loading">
      <div v-for="option in getTags.filter(t => t.active != false)" :key="option.id">
        <el-tag style="margin-bottom: 0.3em" :color="option.color">
          <el-checkbox
            v-model="contactTags[option.id]"
            @change="changeTags(option.id)"
          >
            <span :style="{ color: bgColor(option.color) }">{{
              option.label
            }}</span>
          </el-checkbox>
        </el-tag>
      </div>
    </template>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { processError } from 'src/util/processError.js';

import tagService from 'src/services/tagService.js';
import contactServices from 'src/services/contactServices';

export default {
  props: {
    profileId: {
      type: Number,
      default: () => {
        return 0;
      },
    },
  },
  data() {
    return {
      loading: true,
      contactTags: {},
      contact: undefined,
    };
  },
  computed: {
    ...mapGetters('tags', ['getTags']),
  },
  watch: {
    profileId(n) {
      this.onLoad();
    },
  },
  created() {
    this.onLoad();
  },
  methods: {
    bgColor(bgColor) {
      if (!bgColor) {
        return '#000000';
      }
      var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      var r = parseInt(color.substring(0, 2), 16); // hexToR
      var g = parseInt(color.substring(2, 4), 16); // hexToG
      var b = parseInt(color.substring(4, 6), 16); // hexToB
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    },

    async changeTags(tagId) {
      if (this.contactTags[tagId] === true) {
        const tagSet = this.contact.tags.map(t => ({id: t.id}));
        tagSet.push({id: tagId});
        try {
          await contactServices.patchContact(this.profileId, {tags: tagSet});
        } catch (e) {
          const details = processError(e.response);
          this.$message({
            type: 'error',
            message: 'Error adding Tag: ' + details,
            showClose: true,
          });
          return false;
        }
        this.contact.tags = tagSet;
        this.$emit('update:add-tag', { id: tagId, contactId: this.profileId });
        this.$message({
          message: 'Successfully added tag',
          type: 'success',
        });
      } else if (this.contactTags[tagId] === false) {
        const tagSet = this.contact.tags.filter(t => t.id != tagId).map(t => ({id: t.id}));
        try {
          await contactServices.patchContact(this.profileId, {tags: tagSet});
        } catch (e) {
          const details = processError(e.response);
          this.$message({
            type: 'error',
            message: 'Error removing Tag: ' + details,
            showClose: true,
          });
          return false;
        }
        this.contact.tags = tagSet;
        this.$emit('update:remove-tag', { id: tagId, contactId: this.profileId });
        this.$message({
          message: 'Successfully removed tag',
          type: 'success',
        });
      }
    },
    async onLoad() {
      this.loading = true;
      // We do want to be sure our load and patch are in the same sequence or
      // last update will win. If two people push two changes it will break
      // Need to implement revision on the patch
      const contactData = await contactServices.fetchContactById(
        this.profileId
      );
      this.contact = contactData.data;
      const tmp = {};
      for (const tag of this.getTags) {
        tmp[+tag.id] = false;
      }
      for (const inc in this.contact.tags) {
        const tagId = this.contact.tags[inc].id;
        tmp[+tagId] = true;
      }
      this.contactTags = Object.assign({}, tmp);
      this.loading = false;
    },
  },
};
</script>
